var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('top-bar',{attrs:{"title":"My Apps","icon":"layer-group"}}),_c('b-container',{attrs:{"fluid":""}},[_c('loading-overlay',{attrs:{"is-loading":_vm.loading}},[_c('my-apps-list',{attrs:{"apps":_vm.apps}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }